// @flow

import React, { type ComponentType } from 'react';
import { connect } from 'react-redux';
import {
  StyledPrice,
  Title,
  Content,
  Image,
} from './configPackage.styled';
import { SoldOutOverlay, Pill } from '../default/atoms';
import type { ConfigPackage as ConfigProps } from './types';
import Price from '../../../../../price';
import { getSoldOutLabel, getPerMonthAbbrv } from '../../../../../../store/configuratorSettings/selectors';

type StateProps = {|
  soldOutLabel: string,
  postfix: string,
|};

type Props = {|
  ...ConfigProps,
  ...StateProps,
|};

const ConfigPackage: ComponentType<Props> = ({
  title,
  price,
  active = false,
  imgSrc,
  variant = '',
  soldOut,
  soldOutLabel,
  postfix,
}) => (
  <>
    <Image
      src={imgSrc}
      variant={variant || ''}
    />
    <Content variant={variant || ''}>
      {soldOut && (
        <SoldOutOverlay>
          <Pill>{soldOutLabel}</Pill>
        </SoldOutOverlay>
      )}
      <Title
        active={active}
      >
        {title}
      </Title>
      <StyledPrice
        active={active}
      >
        <Price
          amount={price}
          displayPrefix
          displayCurrencyText
          decimalDash={false}
          postfix={postfix}
        />
      </StyledPrice>
    </Content>
  </>
);

const mapStateToProps = (state): StateProps => ({
  soldOutLabel: getSoldOutLabel(state),
  postfix: getPerMonthAbbrv(state),
});

export default connect<any, ConfigProps, StateProps, any, any, any>(mapStateToProps)(ConfigPackage);
